import { render, staticRenderFns } from "./PendingProductBaseDialog.vue?vue&type=template&id=160a6eac&scoped=true&"
import script from "./PendingProductBaseDialog.vue?vue&type=script&lang=js&"
export * from "./PendingProductBaseDialog.vue?vue&type=script&lang=js&"
import style0 from "./PendingProductBaseDialog.vue?vue&type=style&index=0&id=160a6eac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160a6eac",
  null
  
)

export default component.exports